import {
  stashControlBridgePendingNav,
  type ControlBridgePendingNav,
} from '../../utils/controlBridgePendingNavigation';

export interface ChatNavigationAction {
  type: string;
  label: string;
  route?: string;
  workspaceSlug?: string;
  surface?: string;
  resource?: string;
  artifactItemRef?: string;
  activityItemId?: string;
}

export function readNavigationActionsFromMetadata(
  metadata: Record<string, unknown> | undefined
): ChatNavigationAction[] {
  const raw = metadata?.navigation_actions;
  if (!Array.isArray(raw)) return [];
  return raw.filter((item): item is ChatNavigationAction => {
    return (
      item != null &&
      typeof item === 'object' &&
      typeof (item as ChatNavigationAction).type === 'string' &&
      typeof (item as ChatNavigationAction).label === 'string'
    );
  });
}

export function applyChatNavigationAction(
  action: ChatNavigationAction,
  navigate: (path: string) => void
): void {
  if (action.type !== 'open_control_bridge') return;
  const pending: ControlBridgePendingNav = {
    workspaceSlug: action.workspaceSlug,
    surface: action.surface,
    resource: action.resource,
    artifactItemRef: action.artifactItemRef ?? action.activityItemId,
  };
  stashControlBridgePendingNav(pending);
  const route = action.route?.trim();
  if (route) {
    navigate(route);
  }
}
